import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const ShipRepairsLiabilityClaims = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="ShipRepairsLiabilityClaims" />
                    <HerosectionsAll ScreenName="Ship Repairs Liability Claims" ScreenSearch="hull" />

                    <div className="row col-lg-9 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 faint" style={{ textAlign: 'justify' }}>
                            <h5 className="fw-bold gray_color py-3">Ship Repairs Liability Claims</h5>

                            <p>
                                During its working life, vessel will be taken to the Ship yard for repairs due to accident or for routine dry dock or for overhauling. When it is in care and custody of the ship repairer, he must ensure that it should not get further damaged and at the same time he is also liable for third party damages which may arise from the repair work. This policy indemnifies the ship repairer all sum which they may be legally liable to pay as a ship repairer.
                            </p>

                            <p>
                                We assist in interpretation and application of the policy contact wordings for submitted claim and assist in presentation and handling the claim from intimation till final settlement.
                            </p>

                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
